import { Box, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import { ExamOverviewRow } from "../../../interfaces/examInterfaces";
import BasicMenu from "./SortingTableMenu";
import ArticleIcon from "@mui/icons-material/Article";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";

interface TableRowItemProps {
  handleClickSelectRow: (event: React.MouseEvent<unknown>, selectedRow: ExamOverviewRow) => void;
  row: ExamOverviewRow;
  isItemSelected: boolean | undefined;
  openItem: (itemId: string) => void;
  labelId: string;
  selected: ExamOverviewRow | null;
  accessExpired: Boolean | undefined;
}

export const TableRowItem = ({
  handleClickSelectRow,
  row,
  isItemSelected,
  openItem,
  labelId,
  selected,
  accessExpired,
}: TableRowItemProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (event: React.MouseEvent | React.TouchEvent) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <TableRow
        hover
        onClick={(event) => handleClickSelectRow(event, row)}
        aria-checked={isItemSelected}
        key={row.id}
        selected={isItemSelected}
        sx={{
          cursor: "pointer",
          opacity: accessExpired ? 0.5 : 1,
        }}
        onDoubleClick={() => {
          if (!accessExpired) openItem(row.id);
        }}
        role="checkbox"
        tabIndex={-1}
      >
        <TableCell component="th" id={labelId} scope="row" padding="none">
          <ArticleIcon />
        </TableCell>
        {Object.keys(row)
          .filter((key) => key !== "isDirectory" && key !== "showOptions" && key !== "id")
          .map((key) => (
            <TableCell key={key} align="left">
              {row[key as keyof ExamOverviewRow]}
            </TableCell>
          ))}
        <TableCell align="left" sx={{ padding: "0 16px" }}>
          {row.id === selected?.id && (
            <Box>
              <Tooltip title="Aktionen anzeigen">
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    handleClickOpenMenu(event);
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          <BasicMenu
            anchorEl={anchorEl}
            open={open}
            handleCloseMenu={handleCloseMenu}
            rowSelected={selected}
            openItem={openItem}
            accessExpired={accessExpired}
          />
        </TableCell>
      </TableRow>
    </>
  );
};
